<script setup lang="ts">
import { NON_STREAM_STANDARD_MAX_POST_SIZE, NON_STREAM_WIDE_MAX_POST_SIZE } from '@@/bits/post_size'
import { useSurfaceStore } from '@@/pinia/surface'
import type { Post } from '@@/types'
import SurfacePostCompressed from '@@/vuecomponents/SurfacePostCompressed.vue'
import { storeToRefs } from 'pinia'

defineProps<{
  post: Post
  isTimelinePreview?: boolean
}>()

const { isPostSizeWide } = storeToRefs(useSurfaceStore())
</script>

<template>
  <SurfacePostCompressed
    :post="post"
    class="-rotate-1"
    :is-timeline-preview="isTimelinePreview"
    :style="{
      width: `${isPostSizeWide ? `${NON_STREAM_WIDE_MAX_POST_SIZE}px` : `${NON_STREAM_STANDARD_MAX_POST_SIZE}px`}`,
    }"
  />
</template>
